var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import React, { useState, useEffect, useRef, useMemo } from 'react';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Button } from 'primereact/button';
import { Dropdown } from 'primereact/dropdown';
import { InputNumber } from 'primereact/inputnumber';
import { InputText } from 'primereact/inputtext';
import { Toast } from 'primereact/toast';
import { Tag } from 'primereact/tag';
import { confirmDialog } from 'primereact/confirmdialog';
import { ColumnGroup } from 'primereact/columngroup';
import { Row } from 'primereact/row';
import * as XLSX from 'xlsx';
import { apiService } from '../utils/api';
var LOAN_TYPES = [
    { code: 'SANGAM', principalKey: 'sangamPrincipal', interestKey: 'sangamInterest', label: 'Sangam' },
    { code: 'EDUCATION', principalKey: 'educationPrincipal', interestKey: 'educationInterest', label: 'Education' },
    { code: 'MARRIAGE_BUSINESS', principalKey: 'marriageBusinessPrincipal', interestKey: 'marriageBusinessInterest', label: 'Marriage/Business' },
    { code: 'STARTUP_REVOLVING', principalKey: 'startupRevolvingPrincipal', interestKey: 'startupRevolvingInterest', label: 'Startup/Revolving' },
    { code: 'POOR_STUDENT', principalKey: 'poorStudentPrincipal', interestKey: 'poorStudentInterest', label: 'Poor Student' },
];
var formatINR = function (n) { return new Intl.NumberFormat('en-IN', { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(n || 0); };
var OpeningBalance = function () {
    var toast = useRef(null);
    var fileInputRef = useRef(null);
    var _a = useState([]), fys = _a[0], setFys = _a[1];
    var _b = useState(null), selectedFy = _b[0], setSelectedFy = _b[1];
    var _c = useState([]), members = _c[0], setMembers = _c[1];
    var _d = useState([]), rows = _d[0], setRows = _d[1];
    var _e = useState(null), batch = _e[0], setBatch = _e[1];
    var _f = useState([]), batches = _f[0], setBatches = _f[1];
    var _g = useState(''), notes = _g[0], setNotes = _g[1];
    var _h = useState(false), loading = _h[0], setLoading = _h[1];
    var _j = useState(null), selectedVillage = _j[0], setSelectedVillage = _j[1];
    var _k = useState(null), selectedSangam = _k[0], setSelectedSangam = _k[1];
    var _l = useState([]), villages = _l[0], setVillages = _l[1];
    var _m = useState([]), sangams = _m[0], setSangams = _m[1];
    // Load FYs + members + existing batches on mount
    useEffect(function () {
        void loadFinancialYears();
        void loadAllMembers();
        void loadBatches();
        void loadVillages();
        void loadSangams();
    }, []);
    // When FY changes or batches load, find existing batch
    useEffect(function () {
        if (selectedFy == null)
            return;
        var existing = batches.find(function (b) { return b.financialYearId === selectedFy && b.status !== 'REVERSED'; });
        if (existing) {
            void loadBatch(existing.id);
        }
        else {
            setBatch(null);
            // Pre-populate rows with all members at zero
            setRows(members.map(function (m) { return emptyRow(m); }));
            setNotes('');
        }
    }, [selectedFy, batches, members]);
    var emptyRow = function (m) { return ({
        memberId: m.id,
        cpdNo: m.cpdNo || '',
        memberName: m.name,
        savings: 0,
        sangamPrincipal: 0, sangamInterest: 0,
        educationPrincipal: 0, educationInterest: 0,
        marriageBusinessPrincipal: 0, marriageBusinessInterest: 0,
        startupRevolvingPrincipal: 0, startupRevolvingInterest: 0,
        poorStudentPrincipal: 0, poorStudentInterest: 0,
    }); };
    var loadFinancialYears = function () { return __awaiter(void 0, void 0, void 0, function () {
        var r, current;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, apiService.get('/financial-years')];
                case 1:
                    r = _a.sent();
                    if (r.success && r.data) {
                        setFys(r.data);
                        current = r.data.find(function (f) { return f.isCurrent; });
                        if (current)
                            setSelectedFy(current.id);
                    }
                    return [2 /*return*/];
            }
        });
    }); };
    var loadAllMembers = function () { return __awaiter(void 0, void 0, void 0, function () {
        var r;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, apiService.get('/members/slim')];
                case 1:
                    r = _a.sent();
                    if (r.success && r.data)
                        setMembers(r.data);
                    return [2 /*return*/];
            }
        });
    }); };
    var loadVillages = function () { return __awaiter(void 0, void 0, void 0, function () {
        var r;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, apiService.get('/villages')];
                case 1:
                    r = _a.sent();
                    if (r.success && r.data)
                        setVillages(r.data);
                    return [2 /*return*/];
            }
        });
    }); };
    var loadSangams = function () { return __awaiter(void 0, void 0, void 0, function () {
        var r;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, apiService.get('/sangams')];
                case 1:
                    r = _a.sent();
                    if (r.success && r.data) {
                        setSangams(r.data.map(function (s) {
                            var _a, _b, _c;
                            return ({
                                id: s.id,
                                name: s.name || "Sangam ".concat((_a = s.sangamNo) !== null && _a !== void 0 ? _a : s.id),
                                villageId: (_c = (_b = s.village) === null || _b === void 0 ? void 0 : _b.id) !== null && _c !== void 0 ? _c : s.villageId,
                            });
                        }));
                    }
                    return [2 /*return*/];
            }
        });
    }); };
    var loadBatches = function () { return __awaiter(void 0, void 0, void 0, function () {
        var r;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, apiService.get('/opening-balance/batches')];
                case 1:
                    r = _a.sent();
                    if (r.success && r.data)
                        setBatches(r.data.data || []);
                    return [2 /*return*/];
            }
        });
    }); };
    var loadBatch = function (id) { return __awaiter(void 0, void 0, void 0, function () {
        var r, b, memberMap_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    setLoading(true);
                    return [4 /*yield*/, apiService.get("/opening-balance/batches/".concat(id))];
                case 1:
                    r = _a.sent();
                    setLoading(false);
                    if (r.success && r.data) {
                        b = r.data.data;
                        setBatch(b);
                        setNotes(b.notes || '');
                        memberMap_1 = new Map();
                        members.forEach(function (m) { return memberMap_1.set(m.id, emptyRow(m)); });
                        (b.memberSavings || []).forEach(function (s) {
                            var r = memberMap_1.get(s.memberId);
                            if (r)
                                r.savings = Number(s.amount);
                        });
                        (b.memberLoans || []).forEach(function (l) {
                            var r = memberMap_1.get(l.memberId);
                            if (!r)
                                return;
                            var lt = LOAN_TYPES.find(function (t) { return t.code === l.loanTypeCode; });
                            if (!lt)
                                return;
                            r[lt.principalKey] = Number(l.principalOutstanding);
                            r[lt.interestKey] = Number(l.interestPending);
                        });
                        setRows(Array.from(memberMap_1.values()));
                    }
                    return [2 /*return*/];
            }
        });
    }); };
    var editable = batch == null || batch.status === 'DRAFT';
    var saveDraft = function () { return __awaiter(void 0, void 0, void 0, function () {
        var memberSavings, memberLoans, _i, rows_1, row, _a, LOAN_TYPES_1, lt, p, i, r;
        var _b, _c, _d;
        return __generator(this, function (_e) {
            switch (_e.label) {
                case 0:
                    if (!selectedFy) {
                        (_b = toast.current) === null || _b === void 0 ? void 0 : _b.show({ severity: 'warn', summary: 'Pick FY', detail: 'Please select a financial year' });
                        return [2 /*return*/];
                    }
                    memberSavings = [];
                    memberLoans = [];
                    for (_i = 0, rows_1 = rows; _i < rows_1.length; _i++) {
                        row = rows_1[_i];
                        if (row.savings > 0)
                            memberSavings.push({ memberId: row.memberId, amount: row.savings });
                        for (_a = 0, LOAN_TYPES_1 = LOAN_TYPES; _a < LOAN_TYPES_1.length; _a++) {
                            lt = LOAN_TYPES_1[_a];
                            p = row[lt.principalKey];
                            i = row[lt.interestKey];
                            if (p > 0 || i > 0) {
                                memberLoans.push({ memberId: row.memberId, loanTypeCode: lt.code, principalOutstanding: p, interestPending: i });
                            }
                        }
                    }
                    setLoading(true);
                    return [4 /*yield*/, apiService.post('/opening-balance/save-draft', {
                            batchId: batch === null || batch === void 0 ? void 0 : batch.id,
                            financialYearId: selectedFy,
                            notes: notes,
                            memberSavings: memberSavings,
                            memberLoans: memberLoans,
                        })];
                case 1:
                    r = _e.sent();
                    setLoading(false);
                    if (!r.success) return [3 /*break*/, 3];
                    (_c = toast.current) === null || _c === void 0 ? void 0 : _c.show({ severity: 'success', summary: 'Saved', detail: 'Draft saved' });
                    return [4 /*yield*/, loadBatches()];
                case 2:
                    _e.sent();
                    return [3 /*break*/, 4];
                case 3:
                    (_d = toast.current) === null || _d === void 0 ? void 0 : _d.show({ severity: 'error', summary: 'Error', detail: r.error || 'Save failed', life: 6000 });
                    _e.label = 4;
                case 4: return [2 /*return*/];
            }
        });
    }); };
    var submit = function () { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            if (!batch)
                return [2 /*return*/];
            confirmDialog({
                message: 'Submit this batch for approval? After submission you cannot edit until rejected/reverted.',
                header: 'Confirm Submit',
                icon: 'pi pi-exclamation-triangle',
                accept: function () { return __awaiter(void 0, void 0, void 0, function () {
                    var r;
                    var _a, _b;
                    return __generator(this, function (_c) {
                        switch (_c.label) {
                            case 0: return [4 /*yield*/, apiService.post("/opening-balance/batches/".concat(batch.id, "/submit"), {})];
                            case 1:
                                r = _c.sent();
                                if (!r.success) return [3 /*break*/, 4];
                                (_a = toast.current) === null || _a === void 0 ? void 0 : _a.show({ severity: 'success', summary: 'Submitted' });
                                return [4 /*yield*/, loadBatches()];
                            case 2:
                                _c.sent();
                                return [4 /*yield*/, loadBatch(batch.id)];
                            case 3:
                                _c.sent();
                                return [3 /*break*/, 5];
                            case 4:
                                (_b = toast.current) === null || _b === void 0 ? void 0 : _b.show({ severity: 'error', summary: 'Error', detail: r.error, life: 6000 });
                                _c.label = 5;
                            case 5: return [2 /*return*/];
                        }
                    });
                }); },
            });
            return [2 /*return*/];
        });
    }); };
    var revertToDraft = function () { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            if (!batch)
                return [2 /*return*/];
            confirmDialog({
                message: 'Revert this batch to Draft so you can edit member opening balances again? (Only possible before it is locked.)',
                header: 'Confirm Revert to Draft',
                icon: 'pi pi-exclamation-triangle',
                accept: function () { return __awaiter(void 0, void 0, void 0, function () {
                    var r;
                    var _a, _b;
                    return __generator(this, function (_c) {
                        switch (_c.label) {
                            case 0: return [4 /*yield*/, apiService.post("/opening-balance/batches/".concat(batch.id, "/revert-to-draft"), {})];
                            case 1:
                                r = _c.sent();
                                if (!r.success) return [3 /*break*/, 4];
                                (_a = toast.current) === null || _a === void 0 ? void 0 : _a.show({ severity: 'success', summary: 'Reverted to Draft', detail: 'You can now edit member opening balances' });
                                return [4 /*yield*/, loadBatches()];
                            case 2:
                                _c.sent();
                                return [4 /*yield*/, loadBatch(batch.id)];
                            case 3:
                                _c.sent();
                                return [3 /*break*/, 5];
                            case 4:
                                (_b = toast.current) === null || _b === void 0 ? void 0 : _b.show({ severity: 'error', summary: 'Error', detail: r.error, life: 6000 });
                                _c.label = 5;
                            case 5: return [2 /*return*/];
                        }
                    });
                }); },
            });
            return [2 /*return*/];
        });
    }); };
    var approve = function () { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            if (!batch)
                return [2 /*return*/];
            confirmDialog({
                message: 'Approve and LOCK this batch? Posts a journal entry and creates live loan records. This action is final — only reversal is possible.',
                header: 'Confirm Approve & Lock',
                icon: 'pi pi-exclamation-triangle',
                accept: function () { return __awaiter(void 0, void 0, void 0, function () {
                    var r;
                    var _a, _b;
                    return __generator(this, function (_c) {
                        switch (_c.label) {
                            case 0: return [4 /*yield*/, apiService.post("/opening-balance/batches/".concat(batch.id, "/approve"), {})];
                            case 1:
                                r = _c.sent();
                                if (!r.success) return [3 /*break*/, 4];
                                (_a = toast.current) === null || _a === void 0 ? void 0 : _a.show({ severity: 'success', summary: 'Locked', detail: 'Journal posted, loans created' });
                                return [4 /*yield*/, loadBatches()];
                            case 2:
                                _c.sent();
                                return [4 /*yield*/, loadBatch(batch.id)];
                            case 3:
                                _c.sent();
                                return [3 /*break*/, 5];
                            case 4:
                                (_b = toast.current) === null || _b === void 0 ? void 0 : _b.show({ severity: 'error', summary: 'Error', detail: r.error, life: 8000 });
                                _c.label = 5;
                            case 5: return [2 /*return*/];
                        }
                    });
                }); },
            });
            return [2 /*return*/];
        });
    }); };
    var reverse = function () { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            if (!batch)
                return [2 /*return*/];
            confirmDialog({
                message: 'Reverse this LOCKED batch? Posts a reversing journal and removes OB-derived loans. Blocked if any payment exists.',
                header: 'Confirm Reverse',
                icon: 'pi pi-exclamation-triangle',
                acceptClassName: 'p-button-danger',
                accept: function () { return __awaiter(void 0, void 0, void 0, function () {
                    var r;
                    var _a, _b;
                    return __generator(this, function (_c) {
                        switch (_c.label) {
                            case 0: return [4 /*yield*/, apiService.post("/opening-balance/batches/".concat(batch.id, "/reverse"), {})];
                            case 1:
                                r = _c.sent();
                                if (!r.success) return [3 /*break*/, 3];
                                (_a = toast.current) === null || _a === void 0 ? void 0 : _a.show({ severity: 'success', summary: 'Reversed' });
                                return [4 /*yield*/, loadBatches()];
                            case 2:
                                _c.sent();
                                setBatch(null);
                                return [3 /*break*/, 4];
                            case 3:
                                (_b = toast.current) === null || _b === void 0 ? void 0 : _b.show({ severity: 'error', summary: 'Error', detail: r.error, life: 8000 });
                                _c.label = 4;
                            case 4: return [2 /*return*/];
                        }
                    });
                }); },
            });
            return [2 /*return*/];
        });
    }); };
    var downloadTemplate = function () {
        var headers = [
            'memberId', 'cpdNo', 'memberName', 'savings',
            'sangamPrincipal', 'sangamInterest',
            'educationPrincipal', 'educationInterest',
            'marriageBusinessPrincipal', 'marriageBusinessInterest',
            'startupRevolvingPrincipal', 'startupRevolvingInterest',
            'poorStudentPrincipal', 'poorStudentInterest',
        ];
        var scopedMembers = members.filter(function (m) {
            var _a, _b;
            return (selectedVillage == null || ((_a = m.village) === null || _a === void 0 ? void 0 : _a.id) === selectedVillage) &&
                (selectedSangam == null || ((_b = m.sangam) === null || _b === void 0 ? void 0 : _b.id) === selectedSangam);
        });
        var data = scopedMembers.map(function (m) { return ({
            memberId: m.id,
            cpdNo: m.cpdNo || '',
            memberName: m.name,
            savings: 0,
            sangamPrincipal: 0, sangamInterest: 0,
            educationPrincipal: 0, educationInterest: 0,
            marriageBusinessPrincipal: 0, marriageBusinessInterest: 0,
            startupRevolvingPrincipal: 0, startupRevolvingInterest: 0,
            poorStudentPrincipal: 0, poorStudentInterest: 0,
        }); });
        var ws = XLSX.utils.json_to_sheet(data, { header: headers });
        var wb = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(wb, ws, 'OpeningBalance');
        XLSX.writeFile(wb, 'opening_balance_template.xlsx');
    };
    var handleFileUpload = function (e) {
        var _a;
        var file = (_a = e.target.files) === null || _a === void 0 ? void 0 : _a[0];
        if (!file)
            return;
        var reader = new FileReader();
        reader.onload = function (ev) {
            var _a, _b, _c;
            try {
                var data = new Uint8Array((_a = ev.target) === null || _a === void 0 ? void 0 : _a.result);
                var wb = XLSX.read(data, { type: 'array' });
                var ws = wb.Sheets[wb.SheetNames[0]];
                var json = XLSX.utils.sheet_to_json(ws);
                var memberMap_2 = new Map();
                members.forEach(function (m) { return memberMap_2.set(m.id, emptyRow(m)); });
                for (var _i = 0, json_1 = json; _i < json_1.length; _i++) {
                    var r = json_1[_i];
                    var id = Number(r.memberId);
                    if (!memberMap_2.has(id))
                        continue;
                    var row = memberMap_2.get(id);
                    row.savings = Number(r.savings) || 0;
                    row.sangamPrincipal = Number(r.sangamPrincipal) || 0;
                    row.sangamInterest = Number(r.sangamInterest) || 0;
                    row.educationPrincipal = Number(r.educationPrincipal) || 0;
                    row.educationInterest = Number(r.educationInterest) || 0;
                    row.marriageBusinessPrincipal = Number(r.marriageBusinessPrincipal) || 0;
                    row.marriageBusinessInterest = Number(r.marriageBusinessInterest) || 0;
                    row.startupRevolvingPrincipal = Number(r.startupRevolvingPrincipal) || 0;
                    row.startupRevolvingInterest = Number(r.startupRevolvingInterest) || 0;
                    row.poorStudentPrincipal = Number(r.poorStudentPrincipal) || 0;
                    row.poorStudentInterest = Number(r.poorStudentInterest) || 0;
                }
                setRows(Array.from(memberMap_2.values()));
                (_b = toast.current) === null || _b === void 0 ? void 0 : _b.show({ severity: 'success', summary: 'Imported', detail: "".concat(json.length, " rows merged") });
            }
            catch (err) {
                (_c = toast.current) === null || _c === void 0 ? void 0 : _c.show({ severity: 'error', summary: 'Import failed', detail: err.message });
            }
            finally {
                if (fileInputRef.current)
                    fileInputRef.current.value = '';
            }
        };
        reader.readAsArrayBuffer(file);
    };
    // Members visible in the table: filtered by selected village + sangam.
    // Editing still updates the full `rows` state, so values for other sangams persist
    // and are saved together when Save Draft is clicked.
    var visibleRows = useMemo(function () {
        if (selectedSangam == null)
            return [];
        var memberIds = new Set(members
            .filter(function (m) {
            var _a, _b;
            return ((_a = m.sangam) === null || _a === void 0 ? void 0 : _a.id) === selectedSangam
                && (selectedVillage == null || ((_b = m.village) === null || _b === void 0 ? void 0 : _b.id) === selectedVillage);
        })
            .map(function (m) { return m.id; }));
        return rows.filter(function (r) { return memberIds.has(r.memberId); });
    }, [rows, members, selectedVillage, selectedSangam]);
    // Map memberId → its index in `rows` so cell edits hit the right row even when
    // the table renders a filtered subset.
    var rowIndexByMemberId = useMemo(function () {
        var m = new Map();
        rows.forEach(function (r, i) { return m.set(r.memberId, i); });
        return m;
    }, [rows]);
    // memberId → its village/sangam, used to roll up OB rows into summaries below.
    var memberInfoMap = useMemo(function () {
        var m = new Map();
        members.forEach(function (mem) {
            var _a, _b, _c, _d, _e, _f, _g, _h;
            m.set(mem.id, {
                villageId: (_b = (_a = mem.village) === null || _a === void 0 ? void 0 : _a.id) !== null && _b !== void 0 ? _b : -1,
                villageName: (_d = (_c = mem.village) === null || _c === void 0 ? void 0 : _c.name) !== null && _d !== void 0 ? _d : 'Unknown Village',
                sangamId: (_f = (_e = mem.sangam) === null || _e === void 0 ? void 0 : _e.id) !== null && _f !== void 0 ? _f : -1,
                sangamName: (_h = (_g = mem.sangam) === null || _g === void 0 ? void 0 : _g.name) !== null && _h !== void 0 ? _h : 'Unknown Sangam',
            });
        });
        return m;
    }, [members]);
    var buildSummary = function (groupBySangam, filterVillageId) {
        var map = new Map();
        rows.forEach(function (r) {
            var info = memberInfoMap.get(r.memberId);
            if (!info)
                return;
            if (filterVillageId != null && info.villageId !== filterVillageId)
                return;
            var key = groupBySangam ? "".concat(info.villageId, "-").concat(info.sangamId) : "".concat(info.villageId);
            if (!map.has(key)) {
                map.set(key, {
                    key: key,
                    villageId: info.villageId,
                    villageName: info.villageName,
                    sangamId: groupBySangam ? info.sangamId : undefined,
                    sangamName: groupBySangam ? info.sangamName : undefined,
                    memberCount: 0,
                    savings: 0,
                    totalPrincipal: 0,
                    totalInterest: 0,
                });
            }
            var s = map.get(key);
            s.memberCount += 1;
            s.savings += r.savings || 0;
            LOAN_TYPES.forEach(function (lt) {
                s.totalPrincipal += r[lt.principalKey] || 0;
                s.totalInterest += r[lt.interestKey] || 0;
            });
        });
        return Array.from(map.values());
    };
    var villageSummary = useMemo(function () { return buildSummary(false, null).sort(function (a, b) { return a.villageName.localeCompare(b.villageName); }); }, [rows, memberInfoMap]);
    var sangamSummary = useMemo(function () { return buildSummary(true, selectedVillage).sort(function (a, b) { return (a.sangamName || '').localeCompare(b.sangamName || ''); }); }, [rows, memberInfoMap, selectedVillage]);
    var renderSummaryTable = function (data, mode) {
        var grandSavings = data.reduce(function (a, r) { return a + r.savings; }, 0);
        var grandPrincipal = data.reduce(function (a, r) { return a + r.totalPrincipal; }, 0);
        var grandInterest = data.reduce(function (a, r) { return a + r.totalInterest; }, 0);
        return (_jsxs(DataTable, __assign({ value: data, dataKey: "key", size: "small", loading: loading, rowHover: true, onRowClick: function (e) {
                var row = e.data;
                if (mode === 'village')
                    setSelectedVillage(row.villageId);
                else
                    setSelectedSangam(row.sangamId);
            }, emptyMessage: "No opening balance data", footer: _jsxs("div", __assign({ style: { display: 'flex', justifyContent: 'flex-end', gap: '2rem', fontWeight: 600 } }, { children: [_jsxs("span", { children: ["Total Savings: ", formatINR(grandSavings)] }), _jsxs("span", { children: ["Total Principal: ", formatINR(grandPrincipal)] }), _jsxs("span", { children: ["Total Interest: ", formatINR(grandInterest)] }), _jsxs("span", { children: ["Grand Total: ", formatINR(grandSavings + grandPrincipal + grandInterest)] })] })) }, { children: [mode === 'sangam' && _jsx(Column, { field: "villageName", header: "Village" }), _jsx(Column, { field: mode === 'village' ? 'villageName' : 'sangamName', header: mode === 'village' ? 'Village' : 'Sangam' }), _jsx(Column, { field: "memberCount", header: "Members", style: { width: 100, textAlign: 'right' } }), _jsx(Column, { header: "Savings", body: function (r) { return formatINR(r.savings); }, style: { textAlign: 'right' } }), _jsx(Column, { header: "Total Principal", body: function (r) { return formatINR(r.totalPrincipal); }, style: { textAlign: 'right' } }), _jsx(Column, { header: "Total Interest", body: function (r) { return formatINR(r.totalInterest); }, style: { textAlign: 'right' } }), _jsx(Column, { header: "Total OB", body: function (r) { return formatINR(r.savings + r.totalPrincipal + r.totalInterest); }, style: { textAlign: 'right', fontWeight: 600 } })] })));
    };
    var handleCellEdit = function (rowIndex, field, value) {
        if (!editable)
            return;
        var updated = __spreadArray([], rows, true);
        updated[rowIndex][field] = Number(value) || 0;
        setRows(updated);
    };
    var numberCell = function (rowData, _options, field) {
        var _a;
        if (editable) {
            var realIdx_1 = (_a = rowIndexByMemberId.get(rowData.memberId)) !== null && _a !== void 0 ? _a : -1;
            return (_jsx(InputNumber, { value: rowData[field], onValueChange: function (e) { return realIdx_1 >= 0 && handleCellEdit(realIdx_1, field, e.value || 0); }, mode: "decimal", minFractionDigits: 0, maxFractionDigits: 2, min: 0, inputStyle: { width: '100%', textAlign: 'right' } }));
        }
        var v = rowData[field];
        return _jsx("span", __assign({ style: { display: 'block', textAlign: 'right' } }, { children: v ? formatINR(v) : '' }));
    };
    var statusTag = function (s) {
        if (!s)
            return _jsx(Tag, { value: "NEW", severity: "info" });
        var map = {
            DRAFT: 'info',
            SUBMITTED: 'warning',
            LOCKED: 'success',
            REVERSED: 'danger',
        };
        return _jsx(Tag, { value: s, severity: map[s] || 'info' });
    };
    var headerGroup = (_jsxs(ColumnGroup, { children: [_jsxs(Row, { children: [_jsx(Column, { header: "CPD No", rowSpan: 2 }), _jsx(Column, { header: "Member", rowSpan: 2 }), _jsx(Column, { header: "Savings", rowSpan: 2 }), LOAN_TYPES.map(function (lt) { return (_jsx(Column, { header: lt.label, colSpan: 2 }, lt.code)); })] }), _jsx(Row, { children: LOAN_TYPES.flatMap(function (lt) { return [
                    _jsx(Column, { header: "Principal" }, lt.code + '-p'),
                    _jsx(Column, { header: "Interest" }, lt.code + '-i'),
                ]; }) })] }));
    // Footer totals reflect only the currently displayed sangam (visibleRows),
    // so the bottom row matches the entries shown/added for this sangam rather
    // than the grand total across every sangam.
    var footerGroup = (_jsx(ColumnGroup, { children: _jsxs(Row, { children: [_jsx(Column, { footer: "Sangam Totals:", colSpan: 2 }), _jsx(Column, { footer: formatINR(visibleRows.reduce(function (acc, r) { return acc + (r.savings || 0); }, 0)) }), LOAN_TYPES.map(function (lt) {
                    var p = visibleRows.reduce(function (acc, r) { return acc + (r[lt.principalKey] || 0); }, 0);
                    var i = visibleRows.reduce(function (acc, r) { return acc + (r[lt.interestKey] || 0); }, 0);
                    return [
                        _jsx(Column, { footer: formatINR(p) }, lt.code + '-fp'),
                        _jsx(Column, { footer: formatINR(i) }, lt.code + '-fi'),
                    ];
                }).flat()] }) }));
    return (_jsxs("div", __assign({ style: { padding: '1rem' } }, { children: [_jsx(Toast, { ref: toast }), _jsxs("div", __assign({ style: { display: 'flex', gap: '1rem', alignItems: 'center', marginBottom: '1rem', flexWrap: 'wrap' } }, { children: [_jsx("h2", __assign({ style: { margin: 0 } }, { children: "Opening Balance" })), _jsx(Dropdown, { value: selectedFy, options: fys.map(function (f) { return ({ label: f.yearName, value: f.id }); }), onChange: function (e) { return setSelectedFy(e.value); }, placeholder: "Select Financial Year", style: { minWidth: 200 } }), _jsx(Dropdown, { value: selectedVillage, options: villages.map(function (v) { return ({ label: v.name, value: v.id }); }), onChange: function (e) { setSelectedVillage(e.value); setSelectedSangam(null); }, placeholder: "Select Village", showClear: true, style: { minWidth: 180 } }), _jsx(Dropdown, { value: selectedSangam, options: sangams
                            .filter(function (s) { return selectedVillage == null || s.villageId === selectedVillage; })
                            .map(function (s) { return ({ label: s.name, value: s.id }); }), onChange: function (e) { return setSelectedSangam(e.value); }, placeholder: "Select Sangam", showClear: true, disabled: selectedVillage == null, style: { minWidth: 180 } }), batch && (_jsxs(_Fragment, { children: [_jsxs("span", { children: ["As-on: ", _jsx("strong", { children: batch.asOnDate })] }), statusTag(batch.status), batch.journalEntryId && _jsxs("span", { children: ["Journal #", batch.journalEntryId] })] })), _jsx("div", { style: { flexGrow: 1 } }), _jsx(Button, { label: "Download Template", icon: "pi pi-download", outlined: true, onClick: downloadTemplate }), _jsx(Button, { label: "Import Excel", icon: "pi pi-upload", outlined: true, disabled: !editable, onClick: function () { var _a; return (_a = fileInputRef.current) === null || _a === void 0 ? void 0 : _a.click(); } }), _jsx("input", { ref: fileInputRef, type: "file", accept: ".xlsx,.xls", style: { display: 'none' }, onChange: handleFileUpload })] })), _jsx("div", __assign({ style: { marginBottom: '1rem' } }, { children: _jsx(InputText, { value: notes, onChange: function (e) { return setNotes(e.target.value); }, placeholder: "Notes (optional)", disabled: !editable, style: { width: '100%' } }) })), selectedSangam != null ? (_jsxs(DataTable, __assign({ value: visibleRows, dataKey: "memberId", scrollable: true, scrollHeight: "500px", headerColumnGroup: headerGroup, footerColumnGroup: footerGroup, size: "small", loading: loading, emptyMessage: "No members in this sangam" }, { children: [_jsx(Column, { field: "cpdNo", frozen: true, style: { minWidth: 100 } }), _jsx(Column, { field: "memberName", frozen: true, style: { minWidth: 160 } }), _jsx(Column, { field: "savings", body: function (r, opts) { return numberCell(r, opts, 'savings'); }, style: { minWidth: 110 } }), LOAN_TYPES.flatMap(function (lt) { return [
                        _jsx(Column, { field: lt.principalKey, body: function (r, opts) { return numberCell(r, opts, lt.principalKey); }, style: { minWidth: 110 } }, lt.code + '-p'),
                        _jsx(Column, { field: lt.interestKey, body: function (r, opts) { return numberCell(r, opts, lt.interestKey); }, style: { minWidth: 110 } }, lt.code + '-i'),
                    ]; })] }))) : (_jsxs(_Fragment, { children: [_jsx("div", __assign({ style: { marginBottom: '0.5rem', color: '#666' } }, { children: selectedVillage != null
                            ? 'Opening balance by Sangam — click a row to view/edit its members.'
                            : 'Opening balance by Village — click a row to drill into its Sangams.' })), renderSummaryTable(selectedVillage != null ? sangamSummary : villageSummary, selectedVillage != null ? 'sangam' : 'village')] })), _jsxs("div", __assign({ style: { display: 'flex', gap: '0.5rem', marginTop: '1rem', justifyContent: 'flex-end' } }, { children: [(!batch || batch.status === 'DRAFT') && (_jsxs(_Fragment, { children: [_jsx(Button, { label: "Save Draft", icon: "pi pi-save", onClick: saveDraft }), batch && _jsx(Button, { label: "Submit for Approval", icon: "pi pi-send", severity: "warning", onClick: submit, disabled: !batch })] })), (batch === null || batch === void 0 ? void 0 : batch.status) === 'SUBMITTED' && (_jsxs(_Fragment, { children: [_jsx(Button, { label: "Revert to Draft", icon: "pi pi-undo", severity: "secondary", onClick: revertToDraft }), _jsx(Button, { label: "Approve & Lock", icon: "pi pi-check", severity: "success", onClick: approve })] })), (batch === null || batch === void 0 ? void 0 : batch.status) === 'LOCKED' && (_jsx(Button, { label: "Reverse", icon: "pi pi-undo", severity: "danger", onClick: reverse }))] }))] })));
};
export default OpeningBalance;
